import apiClient from "../common/apiClient.js";

export default class ChangePasswordController {
  async Update(data, token) {
    try {
      return await apiClient.post(
        "/tenant/changepassword",
        data,
        { headers: { Authorization: `Bearer ${token}` } }
      );
    } catch (error) {
      return error;
    }
  }
}
